import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getVisitorId = () => {
  let id = localStorage.getItem("gal_visitor");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "").slice(0, 32);
    localStorage.setItem("gal_visitor", id);
  }
  return id;
};

axios.defaults.headers.common["X-Visitor-Id"] = getVisitorId();

export const VisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    axios.post(`${API}/visits`, { visitor_id: getVisitorId(), path: pathname, referrer: document.referrer || "", lang: localStorage.getItem("gal-lang") || "fr" }).catch(() => {});
  }, [pathname]);
  return null;
};
